(() => {
  if (customElements.get('featured-collections-caption-fit')) return;

  class CollectionCaptionFit extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.featured-collections--mobile-overlay');
      if (!this.root) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (!this.isConnected || this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.root);
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this.root, {childList: true, characterData: true, subtree: true});
      this.mobile.addEventListener('change', this.schedule);
      document.fonts?.ready.then(this.schedule);
      this.schedule();
    }

    update() {
      this.frame = 0;
      if (!this.isConnected) return;
      this.root.querySelectorAll('.card-collection').forEach(card => {
        const photo = card.querySelector('.card-collection__media');
        const caption = card.querySelector('.card-collection__content');
        const hasImage = card.querySelector('.card-collection__media img');
        // Keep a little room above and below the title; longer text flows below the photo.
        const fits = this.mobile.matches && hasImage && photo && caption
          && caption.scrollHeight <= photo.clientHeight - 24;
        card.classList.toggle('card-collection--caption-overlay', Boolean(fits));
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.mobile?.removeEventListener('change', this.schedule);
    }
  }

  customElements.define('featured-collections-caption-fit', CollectionCaptionFit);
})();
